/**
 * Portal extension install flow: shared event name and default package filename.
 * Kept separate from UI components so utils (e.g. download helper) do not import React modules.
 */
/** Dispatched to open CreateSOPModal in the install-guide view (see Layout listener). */
export const EXTENSION_BANNER_OPEN_INSTALL_MODAL_EVENT = 'cricket-studio:portal:open-install-modal';
/** Default .zip basename when env does not override and the URL path has no filename. */
export const DEFAULT_EXTENSION_PACKAGE_FILENAME = 'cricket-studio-extension.zip';
